import { Link } from "react-router-dom";
import { Container, Overline, Reveal } from "@/components/primitives";
import { LuxeLink } from "@/components/LuxeLink";
import { useFoundingMembers, FoundingCard } from "@/components/sections/FoundingMembers";

export default function FoundingMembersPage() {
  const data = useFoundingMembers();
  const members = data?.properties || [];

  return (
    <div className="relative z-10" data-testid="founding-members-page">
      <section className="pt-40 md:pt-52 pb-14 text-center px-6">
        <Reveal>
          <Overline>The Founding Collection</Overline>
          <h1 className="mt-8 font-serif font-light text-4xl md:text-7xl text-ivory tracking-tight max-w-4xl mx-auto leading-[1.05]">
            The Founding Members.
          </h1>
          <p className="mt-8 text-ivory/60 font-light leading-relaxed max-w-2xl mx-auto">
            The first villas selected to join the VillaFlow Private Collection — founding members
            of a curated network of exceptional properties on the Amalfi Coast.
          </p>
          {data && (
            <div className="mt-10 inline-flex items-end gap-3">
              <span className="font-serif text-5xl md:text-6xl text-gold leading-none" data-testid="founding-members-count">
                {String(data.count).padStart(2, "0")}
              </span>
              <span className="font-serif text-2xl md:text-3xl text-ivory/30 leading-none pb-1">/ {data.target}</span>
            </div>
          )}
        </Reveal>
      </section>

      <Container className="pb-40">
        {data === null ? (
          <p className="text-center text-ivory/40 py-20 text-sm tracking-widest uppercase">Loading…</p>
        ) : members.length === 0 ? (
          <Reveal>
            <div className="text-center py-24 border-y border-ivory/10 max-w-2xl mx-auto">
              <p className="font-serif italic text-3xl text-ivory/70">The Founding Members are being selected.</p>
              <p className="mt-6 text-ivory/50 font-light">The first founding villas will be revealed here soon.</p>
              <div className="mt-10"><LuxeLink to="/apply" variant="outline">Request Consideration</LuxeLink></div>
            </div>
          </Reveal>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
            {members.map((p, i) => <FoundingCard key={p.id} p={p} index={i} />)}
          </div>
        )}
      </Container>
    </div>
  );
}
